import './contact.css'

const Contact = () => {
  return (
    <div className='contact text-center text-white' id='contact'>
        <br />
        <h1>
            contact
        </h1>
        <br />
        <hr />
        <div className='mx-md-auto text-center container'>
            <form >
                <div className='form-group mt-2'>
                   <label htmlFor="Uname">User Name:</label>
                   <input type="text" className='form-control' id='uname' placeholder='Enter Name'/>
                </div>

                <div className='form-group mt-2'>
                   <label htmlFor="email">Email:</label>
                   <input type="email" className='form-control' id='email' placeholder='Enter Email'/>
                </div>
               
                <div className='form-group mt-2'>
                   <label htmlFor="Uname">Message:</label>
                   <textarea className='form-control' placeholder='Message....' col='30' rows="10"></textarea>
                </div>

                <button type='button' className='btn mt-4 mb-4'>Message Me</button>
                
            </form>
        </div>
    </div>
  )
}

export default Contact